export const customStyles = {
  rows: {
    style: {
      minHeight: "105px",
    },
  },
};
